import React from 'react'
import './Alumni.css'
function Alumni() {
  return (
    <>
    <div className="container py-5 alumni_heading">
      <h2 className="text-center mb-1">Our Visits</h2>
      <p className='text-center mb-5'>(Explore our visits to various IITs, with many more to come)</p>

      {/* IIT Jodhpur Section */}
      <div className="mb-5 p-4 border rounded" style={{boxShadow:'0px 0px 10px black'}}>
        <div className="row align-items-center">
          <div className="col-md-4 text-center">
            <img src="/assets/iit jodhpur logo.png" className="img-fluid rounded-circle mb-3" alt="IIT Jodhpur" style={{ maxWidth: '180px' }} />
          </div>
          <div className="col-md-8">
            <h3 className="mb-3">Visit to IIT Jodhpur <span className="badge bg-primary">Featured</span></h3>
            <p className="text-muted">
              Our visit to IIT Jodhpur was a remarkable experience. During this visit, we had the opportunity to:
              <ul className="mt-2">
                <li><strong>Engage in an internship focused on Machine Learning</strong>, where we gained hands-on experience in building and deploying ML models.</li>
                <li><strong>Collaborate with faculty and students</strong> on cutting-edge research projects, broadening our understanding of machine learning and its applications.</li>
              </ul>
              The internship provided us with valuable insights and skills that are crucial for our future careers.
            </p>
          </div>
        </div>
        <div id="jodhpurCarousel" className="carousel slide mt-4" data-bs-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="/assets/iit jodhpur 2.jpg" className="d-block w-100 rounded" alt="IIT Jodhpur Image 1" />
              <div className="carousel-caption d-none d-md-block">
                <h5>INDIAN INSTITUTE OF TECHNOLOGY, JODHPUR</h5>
              </div>
            </div>
            <div className="carousel-item">
              <img src="/assets/iit jodhpur.jpg" className="d-block w-100 rounded" alt="IIT Jodhpur Image 2" />
              <div className="carousel-caption d-none d-md-block">
                <h5>IIT Jodhpur - Highlights</h5>
              </div>
            </div>
            <div className="carousel-item">
              <img src="/assets/iit jodhpur 3.jpg" className="d-block w-100 rounded" alt="IIT Jodhpur Image 2" />
              <div className="carousel-caption d-none d-md-block">
                <h5>IIT Jodhpur - Highlights</h5>
              </div>
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#jodhpurCarousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#jodhpurCarousel" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      {/* IIT Indore Section */}
      <div className="mb-5 p-4 border rounded "style={{boxShadow:'0px 0px 10px black'}}>
        <div className="row align-items-center">
          <div className="col-md-4 text-center">
            <img src="/assets/iit indore logo.png" className="img-fluid rounded-circle mb-3" alt="IIT Indore" style={{ maxWidth: '180px' }} />
          </div>
          <div className="col-md-8">
            <h3 className="mb-3">Visit to IIT Indore <span className="badge bg-success">New</span></h3>
            <p className="text-muted">
              Our experience at IIT Indore was equally enriching. During our time there, we:
              <ul className="mt-2">
                <li><strong>Learned various advanced domains such as AI, ML, and Deep Learning</strong> through intensive workshops and lectures.</li>
                <li><strong>Received certificates and a letter of recommendation from IIT Indore</strong>, recognizing our efforts and achievements in these fields.</li>
              </ul>
              These credentials have significantly boosted our academic and professional profiles.
            </p>
          </div>
        </div>
        <div id="indoreCarousel" className="carousel slide mt-4" data-bs-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="/assets/iit indore.jpeg" className="d-block w-100 rounded" alt="IIT Indore Image 1" />
              <div className="carousel-caption d-none d-md-block">
                <h5>INDIAN INSTITUTE OF TECHNOLOGY, INDORE</h5>
              </div>
            </div>
            <div className="carousel-item">
              <img src="/assets/iit indore 2.jpeg" className="d-block w-100 rounded" alt="IIT Indore Image 2" />
              <div className="carousel-caption d-none d-md-block">
                <h5>IIT Indore - Highlights</h5>
              </div>
            </div>
            <div className="carousel-item">
              <img src="/assets/iit indore 3.jpeg" className="d-block w-100 rounded" alt="IIT Indore Image 2" />
              <div className="carousel-caption d-none d-md-block">
                <h5>IIT Indore - Highlights</h5>
              </div>
            </div>
            <div className="carousel-item">
              <img src="/assets/iit indore 4.jpeg" className="d-block w-100 rounded" alt="IIT Indore Image 2" />
              <div className="carousel-caption d-none d-md-block">
                <h5>IIT Indore - Highlights</h5>
              </div>
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#indoreCarousel" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#indoreCarousel" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
    <div class="container mt-3 alumni_heading" data-aos="fade-up">
  <div class="row" >
    <div class="col-md-10 offset-md-1" >
      <div class="text-center mb-4">
        <h2 class="mb-3">Alumni Corner</h2>
        <p id='alumni'>Welcome to the Alumni Corner of Nest Jabalpur! This is a space dedicated to our esteemed alumni, where you can reconnect with fellow graduates, stay updated on alumni events, and share your success stories and experiences with the Nest community.</p>
      </div>
    </div>
  </div>
</div>

<div class="container mt-5 alumni_heading">
  <h2 class="text-center mb-4" data-aos="fade-up">Pillars Of Inspiration</h2>
  
<div class="row">
    <div class="col-md-6" data-aos="fade-up">
    <div class="alumni-card text-center">
    <img src="/assets/super_senior.jpeg" class="img-fluid rounded-circle mb-3 alumni-img mx-auto" alt="Alumni 1"/>
    <h4>Mr. Priyansh Dwivedi</h4>
    <p><strong>Jabalpur Engineering College</strong></p>
    <p>Mechanical Engg.(Batch,2022)</p>
    <p><strong>Current Position: </strong>Persuing M.Tech from IISc Bangaluru</p>
    <p><strong>Experience Sharing:</strong> Transitioning from hostel to BACE was transformative. Amidst GATE prep, I found harmony between spiritual growth and academic pursuits. BACE wasn't just about equations; it was about balancing life's scales, equipping me for both exams and existence beyond.</p>
</div>
    </div>
    <div class="col-md-6" data-aos="fade-up">
      <div class="alumni-card text-center">
        <img src="/assets/shubham_sir.jpeg" class="img-fluid rounded-circle mb-3 alumni-img mx-auto" alt="Alumni 2"/>
        <h4>Mr. Shubham Gupta</h4>
        <p><strong>Jabalpur Engineering College</strong></p>
        <p>Information Technology(Batch,2023)</p>
        <p><strong>Current Position:</strong> Software Engineer at TCS.</p>
        <p><strong>Experience Sharing:</strong> Before joining BACE, I struggled with a poor study environment and an unproductive social circle. However, my life transformed after becoming part of BACE, where I developed a deep interest in spiritual life and achieved significant academic success as well.</p>
      </div>
    </div>
    <div class="col-md-6" data-aos="fade-up">
      <div class="alumni-card text-center">
        <img src="/assets/abhishek_sir.jpeg" class="img-fluid rounded-circle mb-3 alumni-img mx-auto" alt="Alumni 3"/>
        <h4>Mr. Abhishek Garg</h4>
        <p><strong>Jabalpur Engineering College</strong></p>
        <p>Electrical Engg.(Batch,2023)</p>
        <p><strong>Current Position:</strong> Working with Larsen & Turbo Construction</p>
        <p><strong>Experience Sharing:</strong> Joining BACE in my last year of graduation, I was amazed at how quickly I found a diamond and family-like environment. Despite the short period, I developed deep faith in spiritual life and honed my management skills. The support and sense of community at BACE were instrumental in my personal and professional growth during this pivotal time.</p>
      </div>
    </div>
    <div class="col-md-6" data-aos="fade-up">
      <div class="alumni-card text-center">
        <img src="/assets/ravi_sir1.jpeg" class="img-fluid rounded-circle mb-3 alumni-img mx-auto" alt="Alumni 4"/>
        <h4>Mr. Ravi Pandey</h4>
        <p><strong>Jabalpur Engineering College</strong></p>
        <p>Information Technology(Batch,2024)</p>
        <p><strong>Current Position:</strong> Assitant Service Engineer at Tata Consultancy Services(TCS)</p>
        <p><strong>Experience Sharing:</strong> Discovering BACE through online spiritual lectures during the COVID era was a turning point for me. Developing a deep faith in Lord Shri Krishna, I found myself immersed in both spiritual and academic pursuits like never before. Moreover, the nurturing environment at BACE instilled in me leadership qualities that I never knew I had.</p>
      </div>
    </div>
  </div>
  <h5>To be continued... </h5>
  </div>

    </>
  )
}

export default Alumni
